// src/app/routes/_layout.tsx
import { Outlet, useLoaderData } from "react-router";
import { BackgroundGradient } from "@rennpuls/components/shared/layout/backgroundGradient";
import { MainNavigation } from "@rennpuls/components/shared/layout/mainNavigation";
import { Footer } from "@rennpuls/components/shared/layout/footer";
import { getRacesForThisSeasonFromDate } from "@rennpuls/backend/domain/race/getFeaturedRace";
import {wrapLoader} from "@/lib/wrap-loader";

type LoaderData = {
    racesForThisSeason: Awaited<ReturnType<typeof getRacesForThisSeasonFromDate>>;
};

export const loader = wrapLoader(async () => {
    const racesForThisSeason = await getRacesForThisSeasonFromDate();
    return { racesForThisSeason }
});

export default function Layout() {
    const { racesForThisSeason } = useLoaderData<LoaderData>();

    return (
        <div className="min-h-screen flex flex-col relative">
            <BackgroundGradient />
            <div className="relative z-10 flex flex-col min-h-screen">
                <MainNavigation races={racesForThisSeason} />
                <main className="flex-1 pt-[88px] sm:pt-[104px] md:pt-[120px]">
                    <Outlet />
                </main>
                <Footer />
            </div>
        </div>
    );
}
